export default class FastTrackItem {
	id: string;
	name: string;
	serviceId: string;
	serviceName: string;
	variantId: string;
	variantName: string;
	cost: number;
	baseCost: number;
	productionTime: number;
	productionDepartment: string;
}
